import { Col } from "antd";

export default function ColResponsiveDoble({children}) {
    return (
        <Col xs={24} md={16} xl={10} >
            {children}
        </Col>
    )
}
